module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/martech_bg_pc-0b9f0eac8d98d1fa11d1177257858085.png";